import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Snotify, { SnotifyPosition } from 'vue-snotify';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import API from '@/api';
import Loading from 'vue-loading-overlay';
import Icon from './components/elements/icon.vue';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading);
Vue.use(Vuelidate);
Vue.use(Snotify, {});
Vue.component('icon', Icon);

Vue.prototype.$toast = function toast(type, body, title) {
  const options = {
    timeout: 5000,
    icon: false,
    position: SnotifyPosition.centerTop,
  };
  if (!type) {
    this.$snotify.simple(body, title, options);
  } else {
    this.$snotify[type](body, title, options);
  }
};

Vue.prototype.$notify = function notification(type, body, title) {
  const options = {
    timeout: 5000,
    icon: false,
  };
  if (!type) {
    this.$snotify.simple(body, title, options);
  } else {
    this.$snotify[type](body, title, options);
  }
};

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isAuthenticated) {
    next({ path: '/login' });
  }
  if (to.name === 'landingPage') {
    let newState = {};
    API.getLandingPageSettings()
      .then((response) => {
        const { data } = response;
        newState = {
          ...newState,
          logo_url: data.logo_url,
          settings: {
            business_name: data.business_name,
            redirect_url: data.redirect_url,
            tag_line: data.tag_line,
            merchant_uuid: data.merchant_uuid,
          },
        };
        store.dispatch('setNewState', newState);
        next();
      })
      .catch((err) => {
        next({ name: 'login', query: { error: err.response } });
      });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
